var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7933 1.20659C14.5662 0.980466 14.2966 0.801574 14 0.680252C13.7033 0.558929 13.3856 0.497581 13.0651 0.49975C12.7447 0.50192 12.4278 0.567564 12.1328 0.692892C11.8379 0.818219 11.5707 1.00075 11.3467 1.22993L1.68 10.8966L0.5 15.4999L5.10333 14.3193L14.77 4.65259C14.9992 4.42868 15.1818 4.16155 15.3072 3.86665C15.4326 3.57174 15.4982 3.2549 15.5004 2.93446C15.5026 2.61402 15.4412 2.29633 15.3198 1.99975C15.1985 1.70317 15.0195 1.43359 14.7933 1.20659V1.20659Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0708 1.50647L14.4935 4.92914",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68066 10.8961L5.10666 14.3161",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutline);
export default __webpack_public_path__ + "static/media/PencilOutline.f3453da19eaaac4374a2bdf897470a0d.svg";
export { ForwardRef as ReactComponent };